import { createStore, applyMiddleware, combineReducers } from "redux";
import loginReducer from "./Reducers/loginReducer";

const thunkMiddleware = require("redux-thunk").default;
const mainReducer = combineReducers({
  login: loginReducer,
});
const store = createStore(mainReducer, applyMiddleware(thunkMiddleware));
export default store;
